import { ErrorCardProps, ErrorVariant } from './ErrorCard.types'
import { Flex, Typography } from '@percent/lemonade'

import InternalError from '../../../../assets/images/internal-error.png'
import WrongLinkError from '../../../../assets/images/wrong-link-error.png'
import BlockedCookieError from '../../../../assets/images/blocked-cookies-error.png'
import NotFoundError from '../../../../assets/images/not-found-error.png'

const images: { [key in ErrorVariant]: string } = {
  [ErrorVariant.INTERNAL]: InternalError,
  [ErrorVariant.WRONG_LINK]: WrongLinkError,
  [ErrorVariant.LINK_ALREADY_USED]: WrongLinkError,
  [ErrorVariant.NOT_FOUND]: NotFoundError,
  [ErrorVariant.BLOCKED_COOKIES]: BlockedCookieError,
  [ErrorVariant.OTP_MAX_ATTEMPTS_EXCEEDED]: WrongLinkError
}

export function ErrorCard({ title, subtitle, variant, children }: ErrorCardProps) {
  return (
    <Flex direction="column" align="center" gap={24} pt={48}>
      <img alt="error" src={images[variant]} />
      <Typography variant="h2">{title}</Typography>
      {subtitle && <Typography variant="large">{subtitle}</Typography>}
      {children}
    </Flex>
  )
}

ErrorCard.variants = ErrorVariant
